import CardTooltip from './CardTooltip';

export default CardTooltip;
